import { createContext, useContext, useState, useEffect } from 'react';
import { translations, languageNames, languageFlags, rtlLanguages } from '../i18n/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('app_language');
    return saved || 'ar';
  });

  useEffect(() => {
    localStorage.setItem('app_language', language);
    
    // Set document direction based on language
    const isRTL = rtlLanguages.includes(language);
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    return translations[language]?.[key] || translations['ar'][key] || key;
  };

  const isRTL = rtlLanguages.includes(language);

  const value = {
    language,
    setLanguage,
    t,
    isRTL,
    languageNames,
    languageFlags,
    availableLanguages: Object.keys(translations)
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};
